import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "text-lowercase" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = ["id", "type", "name", "onUpdate:modelValue"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_input_date = _resolveComponent("v-input-date")!
  const _component_v_form_group = _resolveComponent("v-form-group")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    size: "xl",
    "class-name": "modal-fullscreen-lg-down",
    onKeypress: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.meta.valid ? _ctx.createFormGroup() : null), ["prevent"]), ["enter"]))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Añadir')) + " ", 1),
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.formGroupStructure.label), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formStructure.form_groups, (formGroup, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formGroup.form_values, (formValue, index) => {
                    return (_openBlock(), _createBlock(_component_v_form_group, {
                      class: "mb-24",
                      "form-group-class": formValue.class,
                      label: _ctx.$t(formValue.label),
                      "yup-errors-variable": _ctx.errors[formValue.key],
                      key: index
                    }, {
                      default: _withCtx(() => [
                        (formValue.type === 'date')
                          ? (_openBlock(), _createBlock(_component_v_input_date, {
                              key: 0,
                              id: formValue.key,
                              class: _normalizeClass({'is-invalid': !!_ctx.errors[formValue.key]}),
                              value: this[formValue.key],
                              modelValue: this[formValue.key],
                              "onUpdate:modelValue": ($event: any) => ((this[formValue.key]) = $event),
                              "onUpdate:value": ($event: any) => (formValue.value = $event)
                            }, null, 8, ["id", "class", "value", "modelValue", "onUpdate:modelValue", "onUpdate:value"]))
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              id: formValue.key,
                              type: formValue.type,
                              name: formValue.key,
                              class: _normalizeClass(["form-control", {'is-invalid': !!_ctx.errors[formValue.key]}]),
                              autocomplete: "off",
                              onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeInput && _ctx.changeInput(...args))),
                              "onUpdate:modelValue": ($event: any) => ((this[formValue.key]) = $event)
                            }, null, 42, _hoisted_4)), [
                              [_vModelDynamic, this[formValue.key]]
                            ])
                      ]),
                      _: 2
                    }, 1032, ["form-group-class", "label", "yup-errors-variable"]))
                  }), 128))
                ], 64))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            variant: "link-secondary",
            class: "me-24",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.$t('Cancelar'),
            onClick: _ctx.closeModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]),
          _createVNode(_component_v_button, {
            variant: "secondary",
            disabled: !_ctx.meta.valid || _ctx.accepted || _ctx.isEmpty,
            "is-loading": _ctx.accepted,
            "aria-label": _ctx.$t('Añadir'),
            onClick: _ctx.createFormGroup
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "is-loading", "aria-label", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}